module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-switch",
    class: _vm.switchState,
    on: {
      "click": _vm.toggleState
    }
  }, [_c('div', {
    staticClass: "z-switch__node",
    class: _vm.switchState
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-daca65be!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/switch/src/switch.vue
// module id = 146
// module chunks = 2 3